import { Component, Input } from '@angular/core';

import { FlightCategory } from '../models/flight-category.model';


@Component({
  selector: 'app-wx-icon',
  templateUrl: './wx-icon.component.html',
  styleUrls: ['./wx-icon.component.scss']
})
export class WxIconComponent {
  @Input() flightCategory: FlightCategory;

  /**
   * Returns a tooltip to display to the user when hovering over the flight category
   */
  get tooltip(): string {
    return this.flightCategory ? '' : 'Flight category unknown';
  }

  /**
   * Returns the CSS classes to set on the root element based on flight category
   */
  get cssClass(): Object {
    return {
      'wx-icon--lifr': this.flightCategory === 'LIFR',
      'wx-icon--ifr': this.flightCategory === 'IFR',
      'wx-icon--mvfr': this.flightCategory === 'MVFR',
      'wx-icon--vfr': this.flightCategory === 'VFR'
    };
  }
}
